/**
 * App event fired with `true` when a Splat Edit session opens and `false` when it closes. The
 * viewer hides what would draw over the raw scan while it is open (clouds, weather, the
 * procedural sky backdrop) and brings it back afterwards.
 */
export const SPLAT_EDIT_ACTIVE_EVENT = 'splatedit:active';
